import React from 'react'

import CalendarData from '../../../../components/Apps/Components/Calendar/Components/CalendarData';
import CodeBox from '../../CodeBox';

const ToastUICalendar = () => {

  const calendarCode = `
  import React, { useEffect, useState } from 'react';
  import { Calendar as BigCalendar, dateFnsLocalizer } from 'react-big-calendar';
  import { format, parse, startOfWeek, getDay } from 'date-fns';
  import 'react-big-calendar/lib/css/react-big-calendar.css';

  const CalendarData = () => {
    const [events, setEvents] = useState([]);

    // Create a date-fns localizer for react-big-calendar
    const locales = {
      'en-US': require('date-fns/locale/en-US'),
    };

    const localizer = dateFnsLocalizer({
      format,
      parse,
      startOfWeek,
      getDay,
      locales,
    });

    useEffect(() => {
      // Mock events data (this can be fetched from an API)
      const fetchedEvents = [
        {
          title: 'Sample Event 1',
          allDay: true,
          start: new Date(2024, 10, 14),
          end: new Date(2024, 10, 14),
        },
        {
          title: 'Sample Event 2',
          allDay: true,
          start: new Date(2024, 10, 15),
          end: new Date(2024, 10, 15),
        },
        {
          title: "Khadush's Birthday",
          allDay: true,
          start: new Date(2025, 11, 2),
          end: new Date(2025, 11, 2),
        }
      ];

      setEvents(fetchedEvents);
    }, []);

    return (
      <div className="calendar-container">
        <BigCalendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          views={['month']}
        />
      </div>
    );
  };

    export default CalendarData;
  `;

  return (
    <div className="row">
      <div className="col-md-12">
        <div className='card h-100'>
          <div className="rounded-4 mb-3 mb-sm-0 bg-white">
            <div className="card-body">
              <div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
                <h4 className="mb-4">Calendar</h4>
                <p className="lead">Big Calendar is a full featured Calendar component for managing events and dates. It uses modern flexbox for layout, making it super responsive and performant. Leaving most of the layout heavy lifting to the browser.</p>
                <div className="row g-3">
                  <div className="col-12">
                    <div className="rounded-4 " data-lang="html">
                      {/* // x---------------------------------x CodeBox Component x---------------------------------x */}
                      <CodeBox code={calendarCode} auto={true} />
                    </div>
                  </div>
                  <div className="col-12">
                    <div id="calendar" style={{ height: "800px" }}>
                      {/* // x---------------------------------x Big CaLender Component x---------------------------------x */}
                      <CalendarData />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ToastUICalendar